import { render } from "./yingyangcan.vue?vue&type=template&id=2eeb653e&scoped=true"
import script from "./yingyangcan.vue?vue&type=script&lang=js"
export * from "./yingyangcan.vue?vue&type=script&lang=js"

import "./yingyangcan.vue?vue&type=style&index=0&id=2eeb653e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2eeb653e"

export default script